import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { WorksWith } from './components/WorksWith';
import { Marquee } from './components/Marquee';
import { ProblemSection } from './components/ProblemSection';
import { BeforeAfter } from './components/BeforeAfter';
import { WhatsInside } from './components/WhatsInside';
import { PromptDemo } from './components/PromptDemo';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { SocialProof } from './components/SocialProof';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-black text-offwhite font-sans selection:bg-gold/30 selection:text-offwhite relative" data-id="element-0">
      <div className="fixed top-0 left-0 right-0 z-[60]" data-id="element-1">
        <UrgencyBar data-id="element-2" />
      </div>
      <Nav data-id="element-3" />
      <main className="pt-[36px]" data-id="element-4">
        <Hero data-id="element-5" />
        <WorksWith data-id="element-6" />
        <Marquee data-id="element-7" />
        <ProblemSection data-id="element-8" />
        <BeforeAfter data-id="element-9" />
        <WhatsInside data-id="element-10" />
        <PromptDemo data-id="element-11" />
        <BonusesSection data-id="element-12" />
        <BenefitsSection data-id="element-13" />
        <SocialProof data-id="element-14" />
        <FAQ data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
      <StickyCTA data-id="element-18" />
    </div>;
}